'use client'

import { bodyClipContext } from '@/contexts/bodyClip'
import type { FC, PropsWithChildren } from 'react'
import { useCallback, useEffect, useRef, useState } from 'react'

export const BodyClipProvider: FC<PropsWithChildren> = ({ children }) => {
	const reasons = useRef(new Set<string>())
	const [clipped, setClipped] = useState(false)

	const clip = useCallback((reason: string) => {
		reasons.current.add(reason)
		setClipped(reasons.current.size > 0)
	}, [])

	const unclip = useCallback((reason: string) => {
		reasons.current.delete(reason)
		setClipped(reasons.current.size > 0)
	}, [])

	useEffect(() => {
		if (clipped) document.body.classList.add('overflow-clip')
		else document.body.classList.remove('overflow-clip')
	}, [clipped])

	return <bodyClipContext.Provider value={{ clip, unclip }}>{children}</bodyClipContext.Provider>
}
